module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"recordInterview":"Record the interview"}}')
  delete Component.options._Ctor
}
